export const Arr_GeneralInfo = [
  // GeneralInfo
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Full name of the person completing the form",
    name: "completing_the_form_Full_name_of_the_person",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Email address of the person completing the form",
    name: "completing_the_form_Email_of_the_person",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label: "Your relationship to the student",
    name: "completing_the_form_Your_relationship_to_the_student",
    selectValues: ["Mother", "Father", "Legal Guardian"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Please specify your relationship to the student (e.g. foster parent)",
    name: "completing_the_form_relationship_specified",
    onlyAppearIfValueIs: ["Legal Guardian"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "completing_the_form_Your_relationship_to_the_student",
  },
  //Contact 1
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does this contact speak English?",
    name: "Contact_1_Confirmation_is_English_speaking",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "If no, please provide their language here:",
    name: "Contact_1_Confirmation_of_langauage",
    onlyAppearIfValueIs: ["No"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Contact_1_Confirmation_is_English_speaking",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Contact full name",
    name: "Contact_1_full_name",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label: "Relationship to the student:",
    name: "Contact_1_relationship_to_the_student",
    selectValues: ["Mother", "Father", "Legal Guardian"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify the legal guardian's relationship to the student",
    name: "Contact_1_relationship_specified",
    onlyAppearIfValueIs: ["Legal Guardian"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Contact_1_relationship_to_the_student",
  },
  {
    Page: "GeneralInfo",
    TextField: "PhoneNumberFieldForObjectState",
    label: "Contact 1 Mobile phone number (inc. country code)",
    name: "Contact_1_Mobile_phone_number_inc_country_code",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p style={{ textAlign: "left" }}>
        Please choose your area code by selecting the image below
      </p>
    ),
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Contact one email",
    name: "Contact_1_Email",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },

  //Contact 2
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does this contact speak English?",
    name: "Contact_2_Confirmation_is_English_speaking",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "If no, please provide their language here:",
    name: "Contact_2_Confirmation_of_langauage",
    onlyAppearIfValueIs: ["No"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "Contact_2_Confirmation_is_English_speaking",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Contact full name",
    name: "Contact_2_full_name",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Relationship to the student (e.g. family friend, aunt, uncle, education consultant, or group leader)",
    name: "Contact_2_relationship_to_the_student",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "GeneralInfo",
    TextField: "PhoneNumberFieldForObjectState",
    label: "Contact 2 Mobile phone number (inc. country code)",
    name: "Contact_2_Mobile_phone_number_inc_country_code",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p style={{ textAlign: "left" }}>
        Please choose your area code by selecting the image below
      </p>
    ),
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Contact two email",
    name: "Contact_2_Email",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },

  //staying at home
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Will the student be staying at the home address provided above for the duration of their programme",
    name: "staying_at_home",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Do you know where the student will be staying during their summer experience",
    name: "staying_where_do_they_know",
    selectValues: ["With Family", "At a Hotel/ AirBnB", "Undecided"],
    onlyAppearIfValueIs: ["No"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "staying_at_home",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Country",
    name: "staying_at_Country",
    onlyAppearIfValueIs: ["With Family", "At a Hotel/ AirBnB"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "staying_where_do_they_know",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "City",
    name: "staying_at_City",
    onlyAppearIfValueIs: ["With Family", "At a Hotel/ AirBnB"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "staying_where_do_they_know",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "First line of address",
    name: "staying_at_first_line",
    onlyAppearIfValueIs: ["With Family", "At a Hotel/ AirBnB"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "staying_where_do_they_know",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Second line of address",
    name: "staying_at_second_line",
    onlyAppearIfValueIs: ["With Family", "At a Hotel/ AirBnB"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "staying_where_do_they_know",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Postcode / Zipcode",
    name: "staying_at_Postcode_Zipcode",
    onlyAppearIfValueIs: ["With Family", "At a Hotel/ AirBnB"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "staying_where_do_they_know",
    SpecialCondition: "NonAccom",
  },

  //Non res 18+ or 18- trusted adult
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Will the student be aged 18+ at the time of their summer programme  experience",
    name: "will_student_be_18",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Please provide details for who will be the responsible adult staying with the student for the duration of their programme",
    name: "local_named_adult_for_non_res",
    selectValues: ["Contact one", "Contact two", "Other"],
    onlyAppearIfValueIs: ["Yes", "No"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "will_student_be_18",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the trusted adult speak English?",
    name: "local_named_adult_for_non_res_speak_english",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "local_named_adult_for_non_res",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Contact full name",
    name: "local_named_adult_for_non_res_full_name",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "local_named_adult_for_non_res",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Relationship to the student (e.g. family/ friend/ other trusted adult)",
    name: "local_named_adult_for_non_res_relationship",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "local_named_adult_for_non_res",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "TextFieldForObjectState",
    label: "Contact email",
    name: "local_named_adult_for_non_res_email",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "local_named_adult_for_non_res",
    SpecialCondition: "NonAccom",
  },
  {
    Page: "GeneralInfo",
    TextField: "PhoneNumberFieldForObjectState",
    label: "Contact mobile number (including country code)",
    name: "local_named_adult_for_non_res_number",
    onlyAppearIfValueIs: ["Other"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "local_named_adult_for_non_res",
    SpecialCondition: "NonAccom",
    AboveText: (
      <p style={{ textAlign: "left" }}>
        Please choose your area code by selecting the image below
      </p>
    ),
  },
];
